export default "__VITE_ASSET__BnwjQ2ZL__"